import { $, $$ } from './dom.js'

const closeAssignment = (assignmentId) => {
  fetch(`/api/assignments/${assignmentId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ completedAt: Date.now() }),
  })
    .then((response) => response.json())
    .then((data) => {
      location.reload();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

const reopenAssignment = (assignmentId) => {
  fetch(`/api/completed_assignments/${assignmentId}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => response.json())
    .then((data) => {
      location.reload();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

const submitPostRequest = (url, params) => {
  const form = $('<form>');
  form.method = "POST";
  form.action = url;
  form.style.display = 'none';

  Object.entries(params).forEach(([key, value]) => {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
}

const deleteAssignment = (assignmentId) => {
  fetch(`/api/assignments/${assignmentId}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => response.json())
    .then((data) => {
      location.reload();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};

const copyAssignment = (assignmentId, courseId) => {
  submitPostRequest(`/${courseId}/assignments/copy`, { assignmentId });
};

$$('button.done').forEach(b => {
  b.onclick = () => {
    const row = b.closest('tr');
    const assignmentId = row.dataset.assignmentId;
    closeAssignment(assignmentId);
  };
});

$$('button.reopen').forEach(b => {
  b.onclick = () => {
    const row = b.closest('tr');
    const assignmentId = row.dataset.assignmentId;
    reopenAssignment(assignmentId);
  };
});

$$('button.copy').forEach(b => {
  b.onclick = () => {
    const row = b.closest('tr');
    const assignmentId = row.dataset.assignmentId;
    const courseId = b.dataset.courseId;
    copyAssignment(assignmentId, courseId);
  };
});

$$('.delete').forEach(b => {
  b.onclick = () => {
    const row = b.closest('tr');
    const assignmentId = row.dataset.assignmentId;
    deleteAssignment(assignmentId);
  };
});
